import {ProjectColors} from "../../../Enums/Core/projectColors";
import React from "react";
import Dot from "../Dot/Dot";
import {Card, Col, Row} from "react-bootstrap";
import {HIGH_FLOW_LEAK, LOW_FLOW_LEAK, MODERATE_FLOW_LEAK} from "../../../Constants/constants";
import {getMonthLabel} from "../Utils/utils";

export default function TotalLeakAlerts(props) {
    const lastNDays = props.data.nLastDays;
    const lastNTotal = props.data.leakAlerts.current.count;
    const currentHigh = props.data.leakAlerts.current.severity.find((leak) => leak.label === HIGH_FLOW_LEAK).value;
    const currentModerate = props.data.leakAlerts.current.severity.find((leak) => leak.label === MODERATE_FLOW_LEAK).value;
    const currentLow = props.data.leakAlerts.current.severity.find((leak) => leak.label === LOW_FLOW_LEAK).value;
    const lastMonthLabel = getMonthLabel(props.data.leakAlerts.lastMonth.date);
    const lastMonthValue = props.data.leakAlerts.lastMonth.count;
    const lastMonthHigh = props.data.leakAlerts.lastMonth.severity.find((leak) => leak.label === HIGH_FLOW_LEAK).value;
    const lastMonthModerate = props.data.leakAlerts.lastMonth.severity.find((leak) => leak.label === MODERATE_FLOW_LEAK).value;
    const lastMonthLow = props.data.leakAlerts.lastMonth.severity.find((leak) => leak.label === LOW_FLOW_LEAK).value;
    const title = "Last " + lastNDays + " Days";

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Row>
                    <Col>
                        <Card.Title style={{fontWeight: 'bold'}}>Total Leak Alerts</Card.Title>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card.Subtitle className={'text-muted'}>{title}</Card.Subtitle>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Card.Text>
                            <LeakAlerts title={title} total={lastNTotal}
                                        high={currentHigh} moderate={currentModerate} low={currentLow}/>
                        </Card.Text>
                        <hr/>
                        <Card.Subtitle className={'text-muted'}> {lastMonthLabel} </Card.Subtitle>
                        <Card.Text>
                            <LeakAlerts title={lastMonthLabel} total={lastMonthValue}
                                        high={lastMonthHigh} moderate={lastMonthModerate} low={lastMonthLow}/>
                        </Card.Text>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}

const LeakAlerts = (props) => {
    return (
        <Row>
            <Col md={5}>
                <p style={{fontWeight: 'bold', color: ProjectColors.DarkRed, marginTop: '1.1rem', fontSize: '1.5rem'}}>{props.total.toLocaleString()}</p>
            </Col>
            <Col md={7}>
                <Row>
                    <Col>
                        <Dot color={ProjectColors.DarkRed} name={'High'} value={props.high}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Dot color={ProjectColors.Orange} name={'Moderate'} value={props.moderate}/>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Dot color={ProjectColors.Yellow} name={'Low'} value={props.low}/>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}